const React = require('react');
const Ripple = require('../../../../Ripple');

module.exports = ({onClick, onDelete, children, deleteIsHidden, isActive}) => {

  const BtnC = onClick ? Ripple : 'div';

  return (
    <div className="rlv">
      <BtnC
        className={
          `w206 h45 layoutRow aiC c0 bgFAFAFA r9 bxsh4c0.25 ovH
                    (cF|bg3E4044).active`
          + (isActive ? ' active' : '')
        }
        onClick={onClick}
      >
        <span
          className={
            `dB fx1 ml14 mr40 mr14.active ovH tov ws`
            + (isActive ? ' active' : '')
          }
        >
          {children}
        </span>
      </BtnC>
      <Ripple
        className={
          `w26 h45 abs st sr layoutRow jcC aiC bg3E4044 rrt9 rrb9
                    dN.hidden bgFAFAFA.active`
          + (deleteIsHidden ? ' hidden' : '')
          + (isActive ? ' active' : '')
        }
        onClick={onDelete}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.07076 0.949747L15.0916 12.9706L12.9703 15.0919L0.94944 3.07107L3.07076 0.949747Z" fill="#73757A"/>
          <path d="M15.0916 3.07107L3.07076 15.0919L0.949439 12.9706L12.9703 0.949747L15.0916 3.07107Z" fill="#73757A"/>
        </svg>
      </Ripple>
    </div>
  )
}
